import React,{Component} from 'react'
import PropTypes from "prop-types";
import {
  Layout,
} from 'antd';
import SideMenu from './components/sideMenu/sideMenu'
import FootContent from './components/footContent/footContent';
import  menuList from '../../routes'
import './main.less'
const {
  Header, Content, Footer,
} = Layout;
class Main extends Component{
     state = {
    collapsed: false,
  };
   static contextTypes = {
            router: PropTypes.object.isRequired,
        }
  changeRouter(router){
    console.log(router, '...router.....')
    this.context.router.push(router)
  }
  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  }
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }
    render(){
        let {children, location} = this.props
        const isPayForKnowledgePage = location && location.pathname === '/payForKnowledge'
        return (
          <Layout className="ant-layout" style={{ minHeight: '100vh', minWidth: '1200px', background: '#fff' }}>
             {!isPayForKnowledgePage && (
            <Header className="ant-layout-header" style={{ background: '#fff', padding: 0 }}>
              {/* <HeaderBar routes={routes} onToggle={this.toggle.bind(this)} collapsed={this.state.collapsed} ></HeaderBar> */}
              <SideMenu menuList={menuList} changeRouter={this.changeRouter.bind(this)}></SideMenu>
            </Header>
             )}
            <Content style={{ margin: '0 0px', paddingTop: isPayForKnowledgePage ? 0 : undefined }}>
              {/* <RouterHistory></RouterHistory> */}
              <div className="content-style">
                {children}
              </div>
            </Content>
            {!isPayForKnowledgePage && (
              <Footer style={{ textAlign: 'center', padding: '0', }}>
                <FootContent></FootContent>
              </Footer>
            )}
        {/* <Sider
          collapsible
          collapsed={this.state.collapsed}
          onCollapse={this.onCollapse}
        >
           <SideMenu  menuList={menuList} changeRouter={this.changeRouter.bind(this)}></SideMenu>
        </Sider>
        `<Layout  >
           
        </Layout>` */}
      </Layout>
        )
    }
}

export default Main